import { useEffect, useState } from "react";
import { getHyphenedDate } from "../../../../utils/utils";
import { postSalesPurchaseTransferSearchInfoListAPI } from "../../../../http/api/SalesPurchaseTransferAPI";

/**
 * 仕入売上振替情報を保持するhook
 */
const useSalesPurchaseTransferPageInfo = () => {

  /**
   * 仕入売上振替情報のリストを保持するState
   */
  const [salesPurchaseTransferInfo, setSalesPurchaseTransferInfo] = useState({});

  /**
   * 集計対象日を保持するstate
   */
  const [totalDate, setTotalDate] = useState(getHyphenedDate(new Date()));

  useEffect(() => {
    (async () => {
      searchSalesPurchaseTransferInfo(getHyphenedDate(new Date()));
    })();
  },[]);
  
  /** 検索を実行する */
  const searchSalesPurchaseTransferInfo = async (totalDate)=> {
    let salesPurchaseTransferInfoRes = await fetchSalesPurchaseTransferInfo(totalDate);

    setSalesPurchaseTransferInfo(salesPurchaseTransferInfoRes);
  }

  /** 集計日時を変更する */
  const changeTotalDate = async (totalDate) => {
    setTotalDate(totalDate);
    searchSalesPurchaseTransferInfo(totalDate);
  };  

  return {
    salesPurchaseTransferInfo,
    totalDate,
    changeTotalDate
  }
}

export default useSalesPurchaseTransferPageInfo;

/** 売上仕入振替情報をサーバから取得する */
const fetchSalesPurchaseTransferInfo = async (totalDate) => {

  const res = await postSalesPurchaseTransferSearchInfoListAPI({totalDate});

  return res;

}

